import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../app/common/reduxs/async/asyncActions';
import {
  jadwalsGet,
  jadwalJenjangsGet,
  jadwalYearsGet,
  jadwalSemsGet,
  jadwalKelassGet,
  jadwalPelajaransGet,
  jadwalGurusGet,
  jadwalAdd,
  jadwalEdit,
  jadwalGet,
  jadwalSettingEdit,
  jadwalDelete,
  jadwalSaveEvents,
  jadwalClashTeachers,
} from './reduxAction';
import { ASYNC_ACTION_START } from '../../../../app/common/reduxs/async/asyncConstant';
import { checkErr } from '../../../../app/common/helpers/checkRes';
import { fetchFunc } from '../../../../app/common/helpers/fetchHelpers';
import { logsFunc } from '../../../../app/common/helpers/othersHelpers';
import { toastr } from 'react-redux-toastr';
import { SITE_ADDRESS } from '../../../../app/common/data/siteConfig';
import { saveAs } from 'file-saver';

export const getJadwals = ({
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwals' });
    const formData = new FormData();
    formData.append('itemPerPage', itemPerPage ? itemPerPage : 10);
    formData.append('currentPage', currentPage);
    formData.append('searchText', searchText);
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'jadwal/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      const search = {
        currentPage,
        searchText,
        itemPerPage: itemPerPage ? itemPerPage : 10,
      };
      dispatch(jadwalsGet({ total, items, search }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalJenjangs = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalJenjangs' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'jenjang/all',
        formData,
        dispatch
      );
      const jenjangs = res.jenjangs;
      dispatch(jadwalJenjangsGet(jenjangs));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalYears = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalYears' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'year/all',
        formData,
        dispatch
      );

      const years = res.years;
      dispatch(jadwalYearsGet(years));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalSems = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalSems' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'sem/all',
        formData,
        dispatch
      );
      const sems = res.sems;
      dispatch(jadwalSemsGet(sems));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalKelass = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalKelass' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'kelas/all',
        formData,
        dispatch
      );
      const kelass = res.kelass;
      dispatch(jadwalKelassGet(kelass));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalPelajarans = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalPelajarans' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'pelajaran/all',
        formData,
        dispatch
      );
      const pelajarans = res.pelajarans;
      dispatch(jadwalPelajaransGet(pelajarans));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalGurus = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalGurus' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'guru/all',
        formData,
        dispatch
      );
      const gurus = res.gurus;
      dispatch(jadwalGurusGet(gurus));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'addJadwal' });
    let logs = logsFunc('create', auth.userId, auth.username, null);
    const formData = new FormData();
    formData.append('id', values.id);
    formData.append('title', values.title);
    formData.append('jenjang', values.jenjang);
    formData.append('year', values.year);
    formData.append('sem', values.sem);
    formData.append(
      'creator',
      JSON.stringify({ creatorId: auth.userId, creatorName: auth.username })
    );
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'jadwal/add/',
        formData,
        dispatch
      );
      const jadwal = res.jadwal;
      dispatch(jadwalAdd(jadwal));
      history.push('/administrasi/jadwal/edit/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const copyJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'copyJadwal' });
    let logs = logsFunc('create', auth.userId, auth.username, null);
    const formData = new FormData();
    formData.append('id', values.id);
    formData.append('title', 'copy of ' + values.title);
    formData.append('description', values.description);
    formData.append('jenjang', values.jenjang);
    formData.append('year', values.year);
    formData.append('sem', values.sem);
    formData.append(
      'creator',
      JSON.stringify({ creatorId: auth.userId, creatorName: auth.username })
    );

    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'jadwal/copy/' + values.id,
        formData,
        dispatch
      );
      const jadwal = res.jadwal;
      console.log(jadwal);

      dispatch(jadwalAdd(jadwal));
      history.push('/administrasi/jadwal/edit-info/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwal = ({ auth, history, id }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwal' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'jadwal/detail/' + id,
        formData,
        dispatch
      );

      const pelajarans = res.pelajarans;
      const gurus = res.gurus;
      const jadwal = res.jadwal;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      const jadwalSetting = res.jadwalSetting;

      dispatch(jadwalGet({ jadwal, pelajarans, gurus, jenjangs, kelass, years, sems, jadwalSetting }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editJadwal' });
    let logs = logsFunc('edit', auth.userId, auth.username, values.logs);
    const formData = new FormData();
    formData.append('description', JSON.stringify(values.events));
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'jadwal/edit/' + values.id,
        formData,
        dispatch
      );
      const jadwal = res.jadwal;
      dispatch(jadwalEdit(jadwal));
      dispatch(jadwalSaveEvents(jadwal));
      history.push('/administrasi/jadwal/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editInfoJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editInfoJadwal' });
    let logs = logsFunc('edit', auth.userId, auth.username, values.logs);
    const formData = new FormData();
    formData.append('title', values.title);
    formData.append('jenjang', values.jenjang);
    formData.append('year', values.year);
    formData.append('sem', values.sem);
    formData.append('creator', JSON.stringify(values.creator));
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'jadwal/edit-info/' + values.id,
        formData,
        dispatch
      );
      const jadwal = res.jadwal;
      dispatch(jadwalEdit(jadwal));
      history.push('/administrasi/jadwal/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const statusJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'statusJadwal' });
    let logs = logsFunc('edit', auth.userId, auth.username, values.logs);
    const formData = new FormData();
    formData.append('published', values.published);
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'jadwal/status/' + values.id,
        formData,
        dispatch
      );
      const jadwal = res.jadwal;

      if (jadwal) {
        toastr.success('Success', 'Status jadwal tersimpan.');
      }
      dispatch(jadwalEdit(jadwal));
      history.push('/administrasi/jadwal/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editJadwalSetting = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editJadwalSetting' });
    let logs = logsFunc('edit', auth.userId, auth.username, values.logs);
    const formData = new FormData();
    formData.append('title', 'setting-jadwal');
    formData.append('description', JSON.stringify(values));
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'jadwal/setting/edit/',
        formData,
        dispatch
      );
      const jadwalSetting = res.jadwalSetting;
      if (jadwalSetting) {
        toastr.success('Success', 'Setting Jadwal tersimpan.');
      }
      dispatch(jadwalSettingEdit(jadwalSetting));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getJadwalSetting = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getJadwalSetting' });
    let logs = logsFunc('edit', auth.userId, auth.username, values?.logs);
    const formData = new FormData();
    formData.append('logs', logs);
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'jadwal/setting/view/',
        formData,
        dispatch
      );
      const jadwalSetting = res.jadwalSetting;
      dispatch(jadwalSettingEdit(jadwalSetting));

      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editJadwalEvents = ({ events }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editJadwalEvents' });
    try {
      dispatch(jadwalSaveEvents(events));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editJadwalClashTeachers = ({ clashTeachers }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editJadwalClashTeachers' });
    try {
      dispatch(jadwalClashTeachers(clashTeachers));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const downloadFile = (auth, history, file) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'downloadFile' });
    const formData = new FormData();
    formData.append('userId', auth.userId);
    formData.append('username', auth.username);

    try {
      const fetchData = await fetch(SITE_ADDRESS+ 'jadwal/download-file/' + file, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const blob = await fetchData.blob();
      saveAs(blob, file);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const importJadwal = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'importJadwal' });
    try {
      let logs = logsFunc('create', auth.userId, auth.username, null);
      const formData = new FormData();
      formData.append('id', values.id);
      formData.append('title', values.title);
      formData.append('jenjang', values.jenjang);
      formData.append('year', values.year);
      formData.append('sem', values.sem);
      formData.append(
        'creator',
        JSON.stringify({
          creatorId: auth.userId,
          creatorName: auth.username,
        })
      );
      formData.append('description', JSON.stringify(values.events));
      formData.append('logs', logs);
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'jadwal/import/' + values.id,
        formData,
        dispatch
      );
      const jadwal = res.jadwal;
      dispatch(jadwalEdit(jadwal));
      history.push('/administrasi/jadwal/' + values.id);
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteJadwal = ({ auth, history, id }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteJadwal' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'jadwal/delete/' + id,
        formData,
        dispatch
      );

      const jadwal = res.jadwal;
      dispatch(jadwalDelete(jadwal));
      history.push('/administrasi/jadwal');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
